export default "__VITE_ASSET__BYyQqA9P__"